/**
 * Predicate narrowing an order table to the search typed above it, matched on the product name and
 * on its SKU. The search is normalized once here rather than on every line: a catalog holds hundreds
 * of them and the filter runs again on each keystroke. An empty search keeps everything.
 *
 * @param {string} search - The search input
 *
 * @returns {Function} A predicate taking a product line
 */
export const buildProductSearchMatcher = (search) => {
  const lowerCasedSearch = search.trim().toLowerCase();

  if (!lowerCasedSearch) {
    return () => true;
  }

  return ({ name, sku }) =>
    (name ?? '').toLowerCase().includes(lowerCasedSearch) ||
    (sku ?? '').toLowerCase().includes(lowerCasedSearch);
};
